<template>
  <div>
    <Modal title="制定审批流程" v-model="modalShow" width="900px" draggable>
      <div>
        <RadioGroup v-model="drawModel">
          <Radio label="create">编辑流程</Radio>
          <Radio label="select">关联已存在的流程</Radio>
        </RadioGroup>
        <Divider />
        <div v-if="drawModel === 'create'">
          <Alert type="warning" show-icon v-if="process.association > 1">此流程有多个关联对象，无法编辑</Alert>
          <Form inline :rules="processRules" ref="processForm" :model="process">
            <FormItem label="流程名称" prop="name" :label-width="70">
              <Input v-model="process.name" style="width: 200px" :maxlength="100" :disabled="process.association > 1" />
            </FormItem>
            <FormItem label="是否有序" :label-width="70">
              <i-switch v-model="process.ordered" :disabled="process.association > 1">
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
            </FormItem>
            <FormItem style="width: 100%;" ref="stepRef">
              <ApprovalSteps :process="process" :show-detail="false" style="margin-bottom: 20px"></ApprovalSteps>
              <div v-for="(item, index) in process.steps" :key="'step_' + index">
                <Form ref="stepForm" inline :model="item" label-position="left" :rules="stepRules">
                  <Alert type="success" style="padding: 0 10px" class="approval-process-step">
                    <FormItem v-if="process.ordered">
                      <Badge :count="index + 1" type="normal"></Badge>
                    </FormItem>
                    <FormItem label="步骤名称" prop="name">
                      <Input v-model="item.name" style="width: 150px" size="small" :maxlength="50" :disabled="process.association > 1" placeholder="如：项目负责人审批" />
                    </FormItem>
                    <FormItem label="对象" :label-width="50" prop="approval_object">
                      <Select v-model="item.approval_object" style="width: 100px" size="small" :disabled="process.association > 1">
                        <Option v-for="approvalObjectItem in approvalObjectList"
                                :key="approvalObjectItem.value"
                                :value="approvalObjectItem.value"
                                v-if="!approvalObjectItem.disabled">{{ approvalObjectItem.label }}</Option>
                      </Select>
                    </FormItem>
                    <FormItem label="可审批的用户" v-if="item.approval_object === 'user'" prop="users">
                      <Select v-model="item.users" multiple filterable style="width: 200px" size="small" :disabled="process.association > 1">
                        <Option v-for="userItem in userList"
                                :key="userItem.id"
                                :value="userItem.id">{{ userItem.name ? userItem.name : userItem.username }}</Option>
                      </Select>
                    </FormItem>
                    <FormItem label="可审批的用户组" v-else-if="item.approval_object === 'group'" prop="group">
                      <Select v-model="item.group" style="width: 200px" size="small" :disabled="process.association > 1">
                        <Option v-for="userGroupItem in userGroupList"
                                :key="userGroupItem.id"
                                :value="userGroupItem.id">{{ userGroupItem.name }}</Option>
                      </Select>
                    </FormItem>
                    <FormItem :label="'可审批的' + tagName" v-else-if="item.approval_object === 'tag'" prop="user_tag">
                      <Select v-model="item.user_tag" style="width: 200px" size="small" :disabled="process.association > 1">
                        <Option v-for="userTagItem in tagList"
                                :key="userTagItem"
                                :value="userTagItem">{{ userTagItem }}</Option>
                      </Select>
                    </FormItem>
                    <span style="float: right;" v-if="!(process.association > 1)">
                    <Tooltip content="前移" style="margin-left: 10px;">
                      <Button @click="stepAction('up', index)" icon="md-arrow-round-up" size="small" type="dashed"></Button>
                    </Tooltip>
                    <Tooltip content="后移" style="margin-left: 10px;">
                      <Button @click="stepAction('down', index)" icon="md-arrow-round-down" size="small" type="dashed"></Button>
                    </Tooltip>
                    <Tooltip content="移除步骤">
                      <a v-on:click="stepAction('remove', index)" style="color: #515a6e; margin-left: 10px; line-height: 32px">
                        <Icon type="md-close" size="15" /></a>
                    </Tooltip>
                </span>
                  </Alert>
                </Form>
              </div>
              <Row v-if="process.steps.length < maxStep && !(process.association > 1)">
                <Button type="dashed" @click="addSteps" size="small" icon="md-add">添加步骤</Button>
              </Row>
            </FormItem>
          </Form>
        </div>
        <div v-else-if="drawModel === 'select'">
          <span style="padding-right: 10px">审批流程</span>
          <Select v-model="selectedProcessIndex" placeholder="请选择一个流程" style="width: 300px;" size="small" clearable filterable @on-change="selectProcessChange">
            <Option v-for="(item, index) in approvalProcessList" :key="item.id" :value="index" :disabled="item.id === process.id">{{ item.name ? item.name : ('审批流程' + ': ' + item.id) }}</Option>
          </Select>
          <ApprovalSteps :process="selectedProcess" style="margin-top: 20px"></ApprovalSteps>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="drawOk" :disabled="drawModel === 'create' && process.association > 1">确定</Button>
        <Button @click="modalShow = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { GetALLUsers, getAllGroup } from '@/api/user'
import { arrayAction } from '@/libs/tools'
import { getApprovalProcess } from '@/api/cmdb'
import ApprovalSteps from '../components/approval-steps'

export default {
  name: 'approval-process',
  components: {
    ApprovalSteps
  },
  props: {
    tagList: {
      type: Array,
      default: function () {
        return []
      }
    },
    tagName: {
      type: String,
      default: '用户标识'
    },
    maxStep: {
      type: Number,
      default: 10
    },
    groupDisabled: {
      type: Boolean,
      default: false
    },
    userDisabled: {
      type: Boolean,
      default: false
    }
  },
  created: function () {
    this.getAllUserData()
    this.getAllGroupData()
    this.getApprovalProcessData()
  },
  data () {
    return {
      modalShow: false,
      drawModel: 'create',

      // 新建流程
      process: {
        name: '',
        steps: [],
        ordered: true
      },
      processRules: {
        name: { required: true, message: '流程名称不能为空', trigger: 'blur' },
        steps: { required: true, type: 'array', validator: this.validArrayRule, min: 1, message: '请添加步骤', trigger: 'change' }
      },
      stepRules: {
        name: { required: true, message: '步骤名称不能为空', trigger: 'blur' },
        group: { required: true, message: '请选择有审批权限的用户组', trigger: 'change', type: 'Number' },
        user_tag: { required: true, message: '请选择有审批权限的' + this.tagName, trigger: 'blur' },
        users: { required: true, type: 'Array', validator: this.validArrayRule, min: 1, message: '请选择有审批权限的用户', trigger: 'change' }
      },
      approvalObjectList: [
        { value: 'tag', label: this.tagName, disabled: !this.tagList.length },
        { value: 'group', label: '用户组', disabled: this.groupDisabled },
        { value: 'user', label: '用户', disabled: this.userDisabled },
        { value: 'auto', label: '自动获取', disabled: false }
      ],
      userList: [],
      userGroupList: [],
      callbackParams: null,

      // 关联已存在的流程
      approvalProcessList: [],
      approvalProcessError: false,
      selectedProcess: null,
      selectedProcessIndex: null
    }
  },
  methods: {
    // 打开对话框
    openModal (process = null, callbackParams) {
      this.drawModel = 'create'
      if (!process || Object.keys(process).length === 0) {
        this.process = {
          name: '',
          steps: [],
          ordered: true
        }
      } else {
        this.process = process
      }
      this.callbackParams = callbackParams
      this.modalShow = true
    },
    // 定制完成
    drawOk () {
      let process
      if (this.drawModel === 'create') {
        process = this.process
        if (process.association > 1) {
          this.$Notice.warning({ title: '此流程有多个关联对象，无法编辑' })
          return
        }
        if (!process.steps.length) {
          this.$Notice.warning({ title: '请添加审批步骤' })
          return
        }
        let allValid = true
        this.$refs['processForm'].validate((valid) => {
          if (!valid) {
            allValid = false
          }
        })
        for (let i in this.$refs['stepForm']) {
          this.$refs['stepForm'][i].validate((valid) => {
            if (!valid) {
              allValid = false
            }
          })
        }
        if (!allValid) {
          this.$Notice.warning({
            title: '表单未填写完整，请检查输入框！'
          })
          return
        }
        for (let i in process.steps) {
          let step = process.steps[i]
          if (step.approval_object === 'user') {
            if (!step.users.length) {
              this.$Notice.warning({ title: '请选择可审批的用户' })
              return
            }
            step.group = null
            step.user_tag = null
          } else if (step.approval_object === 'group') {
            if (!step.group) {
              this.$Notice.warning({ title: '请选择可审批的用户组' })
              return
            }
            step.users = []
            step.user_tag = null
          } else if (step.approval_object === 'tag') {
            if (!step.user_tag) {
              this.$Notice.warning({ title: '请选择可审批的' + this.tagName })
              return
            }
            step.users = []
            step.group = null
          }
        }
      } else if (this.drawModel === 'select') {
        process = this.selectedProcess
        if (!process.id) {
          this.$Notice.warning({ title: '请选择一个审批流程' })
        }
      }
      this.modalShow = false
      this.$emit('drawComplete', process, this.callbackParams)
    },
    // 获取已存在的流程
    getApprovalProcessData () {
      getApprovalProcess().then(res => {
        let process = []
        for (let i in res.data) {
          let approvalObjectIsTag = false
          // for (let v in res.data[i].steps) {
          //   let step = res.data[i].steps[v]
          //   if (step.approval_object === 'tag') {
          //     approvalObjectIsTag = true
          //     break
          //   }
          // }
          if (!approvalObjectIsTag) {
            process.push(res.data[i])
          }
        }
        this.approvalProcessList = process
        this.approvalProcessError = false
      }).catch(res => {
        this.approvalProcessError = true
        console.log(res.response)
      })
    },
    // 获取所有用户数据
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      })
    },
    // 获取所有用户组数据
    getAllGroupData () {
      getAllGroup().then(res => {
        this.userGroupList = res.data
      })
    },
    // 添加步骤
    addSteps () {
      if (this.process.steps.length >= this.maxStep) {
        return
      }
      this.process.steps.push({
        name: '审批步骤' + (this.process.steps.length + 1),
        approval_object: 'user',
        group: null,
        user_tag: null,
        users: [],
        order: this.process.steps.length + 1
      })
    },
    // 数组操作
    stepAction (action, index) {
      let resultValue = arrayAction(this.process.steps, index, action)
      this.process.steps = []
      this.process.steps = resultValue
    },
    selectProcessChange (index) {
      if (index === null) {
        this.selectedProcess = null
      } else {
        this.selectedProcess = this.approvalProcessList[index]
      }
    },
    // 数组校验器
    validArrayRule (rule, value, callback) {
      if (value === 0) {
        callback(new Error())
      } else {
        callback()
      }
    }
  }
}
</script>

<style scoped lang="less">
  .approval-process-step {
    .ivu-form-item {
      margin-bottom: 5px;
      .ivu-form-item-content {
        margin-left: unset;
      }
    }
  }
</style>
